import * as React from "react"

const Button = React.forwardRef(({
  className,
  variant = 'default',
  size = 'default',
  animate = false,
  glow = false,
  ...props
}, ref) => {
  const baseStyles = "inline-flex items-center justify-center rounded-md font-medium transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none relative overflow-hidden transform hover:-translate-y-1"

  const variants = {
    default: "bg-primary text-white hover:bg-primary-600 shadow-md hover:shadow-lg",
    outline: "border-2 border-primary text-primary hover:bg-primary/10",
    ghost: "hover:bg-primary/10 text-primary",
    secondary: "bg-secondary text-background hover:bg-secondary-600 shadow-md hover:shadow-lg",
    danger: "bg-accent text-white hover:bg-accent-600 shadow-md hover:shadow-lg",
    golden: "bg-gradient-to-r from-secondary to-secondary-600 text-background hover:from-secondary-400 hover:to-secondary shadow-golden",
    enchanted: "bg-gradient-to-r from-primary-700 via-primary to-primary-600 text-white shadow-magical hover:from-primary-600 hover:via-primary-500 hover:to-primary-400",
    parchment: "bg-background-paper text-foreground-dark border border-secondary/50 hover:border-secondary shadow-sm hover:shadow"
  }

  const sizes = {
    default: "h-10 py-2 px-4 text-sm",
    sm: "h-8 px-3 text-xs rounded-md",
    md: "h-10 py-2 px-4 text-sm",
    lg: "h-12 px-6 text-base rounded-md",
    xl: "h-14 px-8 text-lg rounded-md",
  }

  const glowEffect = glow ?
    `${variant === 'golden' || variant === 'secondary' ? 'shadow-golden' : 'shadow-magical'}` : '';

  // Add shimmer animation
  const renderShimmer = animate ? (
    <span className="absolute inset-0 overflow-hidden">
      <span className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/10 to-transparent"></span>
    </span>
  ) : null;

  return (
    <button
      ref={ref}
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${glowEffect} ${className}`}
      {...props}
    >
      {renderShimmer}
      {props.children}
    </button>
  )
})
Button.displayName = "Button"

export { Button }